import { Modal } from 'antd';

/**
 * Shows a modal informing that the patient was recently called by another box
 * @param {string} errorMessage - Error message with format "El paciente ha sido llamado en menos de [X] tiempo por el box [nombre]"
 * @param {function} forceRecentCall - Callback to execute when the user confirms calling the patient anyway
 */
export const showBlockedCallModal = (errorMessage, forceRecentCall, t) => {
  const boxMatch = errorMessage.match(/by:\s*(.+)$/i);
  const boxName = boxMatch ? boxMatch[1].trim() : '';

  const modalContent = (
    <div>
      <p className="mb-15">{t('examPage.examTabs.patientCalledRecentlyBy')}:</p>
      <ul className="pl-20 mb-15 mt-10">
        <li className="mb-5">{boxName}</li>
      </ul>
      <p className="mb-0" style={{ fontWeight: 500 }}>
        {t('examPage.examTabs.callPatientAnyway')}
      </p>
    </div>
  );

  Modal.confirm({
    title: t('examPage.examTabs.patientCalledRecently'),
    content: modalContent,
    okText: 'Llamar',
    cancelText: 'Cancelar',
    centered: true,
    width: 500,
    onOk: forceRecentCall,
  });
};

export default showBlockedCallModal;